import classNames from 'classnames/bind';
import AddIcon from '@/assets/svg/add.svg';
import SubtractIcon from '@/assets/svg/subtract.svg';

import style from './Counter.module.scss';
const cx = classNames.bind(style);

type CounterProps = {
  count: number;
  disabled?: boolean;
  onIncrement: () => void;
  onDecrement: () => void;
};

export default function Counter(props: CounterProps) {
  const { count, onIncrement, onDecrement, disabled } = props;

  return (
    <div className={cx("counter")}>
      <button
        className={cx("counter__button")}
        type="button"
        onClick={onDecrement}
        disabled={disabled || count <= 0}
      >
        <SubtractIcon className={cx("icon")} />
      </button>
      <span className={cx("counter__count", "text-m")}>{count}</span>
      <button className={cx(["counter__button", "inc"])} type="button" onClick={onIncrement} disabled={disabled}>
        <AddIcon className={cx("icon")} />
      </button>
    </div>
  );
}